// extracted by mini-css-extract-plugin
export default {"modal_pallex_error":"pallexError_modal_pallex_error__8XPVO","btn_container":"pallexError_btn_container__-BO34","btn":"pallexError_btn__yi7wX"};